const initPerformanceStep = () => {
    const performanceStep = document.querySelector("[data-performance-step]");
    if (performanceStep) {
        const inputField = performanceStep.querySelector("[data-input]");
        const performanceListContainer = performanceStep.querySelector("[data-list]");
        const doctorsContainerToAppend = document.querySelector("[data-doctors-section]");
        const doctorsAfterVenueToAppend = document.querySelector("[data-doctors-after-venue]");
        const venueListContainerToAppend = document.querySelector("[data-venue-list-section]");
        const contactFormToAppend = document.querySelector("[data-contact-form-step]");
        if (inputField && performanceListContainer) {
            let typingTimer = null;
            // time to wait, in milliseconds, after the user stops typing
            const doneTypingInterval = 500;
            // input event of text input
            inputField.addEventListener("input", () => {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            });
            const doneTyping = () => {
                const inputValue = inputField.value;
                const apiUrl = `/GetPerformance?src=${inputValue.toLowerCase()}`;
                // make the API call
                fetch(apiUrl)
                    .then(response => response.json())
                    .then(data => {
                    // add the results as children of the data-list element
                    performanceListContainer.innerHTML = ''; //clear any previous results
                    data.forEach(item => {
                        const option = document.createElement('p');
                        option.classList.add('option');
                        option.textContent = item.Name;
                        performanceListContainer.appendChild(option);
                        option.addEventListener("click", () => {
                            inputField.value = item.Name;
                            inputField.id = item.Id;
                            inputField.innerHTML = item.Name;
                            performanceListContainer.classList.remove("active");
                            performanceListContainer.classList.add("hide");
                            const contactForm = document.querySelector("[data-contact-form-step]");
                            if (contactForm) {
                                contactForm.setAttribute("data-show", "hidden");
                            }
                            const dataDoctorsAfterVenue = document.querySelector("[data-doctors-after-venue]");
                            if (dataDoctorsAfterVenue) {
                                const venueList = dataDoctorsAfterVenue.querySelectorAll("[data-to-append]");
                                venueList.forEach((venue) => {
                                    const radio = venue.querySelector("[data-radio-button]");
                                    radio.removeAttribute("checked");
                                });
                            }
                            const doctorsAfterVenue = document.querySelector("[data-doctors-after-venue]");
                            if (doctorsAfterVenue) {
                                doctorsAfterVenue.setAttribute("data-show", "hidden");
                            }
                            const venueListSection = document.querySelector("[data-venue-list-section]");
                            if (venueListSection) {
                                const venueList = venueListSection.querySelectorAll("[data-venue]");
                                venueList.forEach((venue) => {
                                    const radio = venue.querySelector("[data-radio-button]");
                                    radio.removeAttribute("checked");
                                    radio.value = "false";
                                    radio.checked = false;
                                });
                            }
                            const dataVenueListSection = document.querySelector("[data-venue-list-section]");
                            if (dataVenueListSection) {
                                dataVenueListSection.setAttribute("data-show", "hidden");
                            }
                            const doctorSection = document.querySelector("[data-doctors-section]");
                            if (doctorSection) {
                                const venueList = doctorSection.querySelectorAll("[data-venue]");
                                venueList.forEach((venue) => {
                                    const radio = venue.querySelector("[data-radio-button]");
                                    radio.removeAttribute("checked");
                                    radio.value = "false";
                                    radio.checked = false;
                                });
                            }
                            const dataDoctorSection = document.querySelector("[data-doctors-section]");
                            if (dataDoctorSection) {
                                dataDoctorSection.setAttribute("data-show", "hidden");
                            }
                            const knowDoctorSectionStep = document.querySelector("[data-know-doctor-section-step]");
                            if (knowDoctorSectionStep) {
                                const radioButtonList = knowDoctorSectionStep.querySelectorAll("[data-radio-button]");
                                if (radioButtonList && radioButtonList.length > 0) {
                                    radioButtonList.forEach((radioButton) => {
                                        radioButton.removeAttribute("checked");
                                    });
                                }
                            }
                            doctorsContainerToAppend.setAttribute("data-show", "hidden");
                            venueListContainerToAppend.setAttribute("data-show", "hidden");
                            contactFormToAppend.setAttribute("data-show", "hidden");
                            const containerToAppend = document.querySelector("[data-know-doctor-section-step]");
                            updateUrlParams(containerToAppend, `/GetKnowDoctorSection?stepId=1`, "performanceId", item.Id, initKnowDoctorStep);
                        });
                    });
                    performanceListContainer.classList.add("active");
                    performanceListContainer.classList.remove("hide");
                })
                    .catch(error => console.error(error));
            };
        }
    }
};
